import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { AlertModule, MbsPopupType } from 'mbs-ui-kit';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade'

@Component({
  selector: 'mbs-tfa-configure-alert',
  templateUrl: './tfa-configure-alert.component.html',
  standalone: true,
  imports: [CommonModule, AlertModule, I18NextModule]
})
export class TfaConfigureAlertComponent {
  protected readonly alertType = MbsPopupType;

  constructor(public authFacade: AuthFacade) {}
}
